// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__e6rc2","imageUploader":"EGiftCard_imageUploader__3BKt_"};